import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SectorsHero } from '../components/sectors/SectorsHero';
import { SectorsEcosystems } from '../components/sectors/SectorsEcosystems';
import { SectorsFoundation } from '../components/sectors/SectorsFoundation';
import { SectorsCTA } from '../components/sectors/SectorsCTA';
export function Sectors() {
  return <div className="w-full min-h-screen bg-white" data-id="element-8941" data-mp="dxvjk1wlh2fk">
      <Header data-id="element-8942" data-mp="e19lxa59dbn0" />
      <main className="pt-[120px]" data-id="element-8943" data-mp="ixqag5gdds0m">
        <SectorsHero data-id="element-8944" data-mp="iwyn1hwxf0lf" />
        <SectorsEcosystems data-id="element-8945" data-mp="iw5gagxywb3a" />
        <SectorsFoundation data-id="element-8946" data-mp="nx37tk4vahhg" />
        <SectorsCTA data-id="element-8947" data-mp="nwtg9s46c29n" />
      </main>
      <Footer data-id="element-8948" data-mp="nxmeu5szblgp" />
    </div>;
}